// extracted by mini-css-extract-plugin
module.exports = {"Transcript":"Transcript_Transcript__3uOFr","history":"Transcript_history__2Xyoy","details":"Transcript_details__3jgCx","close":"Transcript_close__2QOLX"};